import axiosClient from 'apis/axios-client';
import { AxiosResponse } from 'axios';



const GET_PROFILE_URL = '/admin/AdminSettings/GetDisplayName';

const UPDATE_PRIVACY_URL = '/admin/AdminSettings/UpdateDisplayName';


export const getAdminProfile = async (): Promise<any> => {
    try {
      const response: AxiosResponse<any> = await axiosClient.get(GET_PROFILE_URL);
      return response; // Return the entire response (no need to access .data)
    } catch (error) {
      if (error instanceof Error) {
        console.error('Error fetching user profile:', error.message);
      } else {
        console.error('Unknown error fetching user profile');
      }
      throw error;
    }
  };

  export const updateDisplayName = async (displayName: string): Promise<any> => {
    try {
      const response: AxiosResponse<any> = await axiosClient.post(
        `${UPDATE_PRIVACY_URL}?DisplayName=${encodeURIComponent(displayName)}`
      );
      return response; // Return the entire response
    } catch (error) {
      if (error instanceof Error) {
        console.error('Error updating privacy settings:', error.message);
      } else {
        console.error('Unknown error updating privacy settings');
      }
      throw error;
    }
  };